// src/lib/storage/authStorage.js
// Filepath: // src/lib/storage/authStorage.js

/**
 * Safe helpers for reading/writing the auth payload in localStorage.
 * Expected shape:
 * localStorage.getItem("authResponseData") ===
 *   '{"token":"<JWT>","...optional fields"}'
 */

const AUTH_KEY = "authResponseData";

/** @returns {null | { token?: string, [k:string]: any }} */
export function getAuthResponseData() {
  try {
    const raw = localStorage.getItem(AUTH_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

/** @returns {string | null} */
export function getAuthToken() {
  const data = getAuthResponseData();
  return data && typeof data.token === "string" && data.token.length > 0
    ? data.token
    : null;
}

/** @param {object|string} value */
export function setAuthResponseData(value) {
  try {
    const raw = typeof value === "string" ? value : JSON.stringify(value);
    localStorage.setItem(AUTH_KEY, raw);
  } catch {
    // no-op
  }
}

export function clearAuth() {
  try {
    localStorage.removeItem(AUTH_KEY);
  } catch {
    // no-op
  }
}
